import { SecurityMasterPatcher } from './security-master-patcher.cls'

/**
 * 
 */
export const NSPatchers = { 
  SecurityMasterPatcher
}
